"use client";

import { createContext, useContext } from "react";

export type PdfViewMode = "pdf" | "diff";

export type PdfViewModeContextValue = {
  viewMode: PdfViewMode;
  setViewMode: (mode: PdfViewMode) => void;
  /** Ref to the diff iframe element — null when not in diff mode. */
  diffIframeRef: React.RefObject<HTMLIFrameElement | null>;
  /** Current numeric zoom applied to the diff iframe (1.0 = 100%). */
  diffZoom: number;
  setDiffZoom: (zoom: number) => void;
};

export const PdfViewModeContext = createContext<PdfViewModeContextValue>({
  viewMode: "pdf",
  setViewMode: () => {},
  diffIframeRef: { current: null },
  diffZoom: 1,
  setDiffZoom: () => {},
});

export function usePdfViewMode(): PdfViewModeContextValue {
  return useContext(PdfViewModeContext);
}
